import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { OrdersStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isLoading: (state: OrdersStore): OrdersStore['loading'] => state.loading,
  getOrders: (state: OrdersStore): OrdersStore['orders'] => state.orders,
  hasOrders: (state: OrdersStore): boolean => isFullArray(state.orders),
  getMeta: (state: OrdersStore): Meta | null => state.meta,
  getFilterSearch: (state: OrdersStore): OrdersStore['filterSearch'] => state.filterSearch,
  getFilterStatuses: (state: OrdersStore): OrdersStore['filterStatuses'] => state.filterStatuses,
  getFilterType: (state: OrdersStore): OrdersStore['filterType'] => state.filterType,
  getFilterFrom: (state: OrdersStore): OrdersStore['filterFrom'] => state.filterFrom,
  getFilterTo: (state: OrdersStore): OrdersStore['filterTo'] => state.filterTo,
  getFilterLessonsFrom: (state: OrdersStore): OrdersStore['filterLessonsFrom'] => state.filterLessonsFrom,
  getFilterLessonsTo: (state: OrdersStore): OrdersStore['filterLessonsTo'] => state.filterLessonsTo,
  getFilterPromocodeId: (state: OrdersStore): OrdersStore['filterPromocodeId'] => state.filterPromocodeId,
  getFilterCustomerId: (state: OrdersStore): OrdersStore['filterCustomerId'] => state.filterCustomerId,
  getCurrentPage: (state: OrdersStore): OrdersStore['currentPage'] => state.currentPage,
  getPerPage: (state: OrdersStore): OrdersStore['perPage'] => state.perPage,
}
